import { Component, OnInit, Input, EventEmitter, OnChanges, Output } from '@angular/core';
import { trigger, transition, animate, keyframes, style} from '@angular/animations';
import { RDDarkService } from './../dark.service';

@Component({
  selector: 'rd-dice',
  template: `<div id="wrapper" [class.rdDark]="dark" (click)="rollDice()">
  <div id="dice" #dice [@turnAnimation]="rolling" (@turnAnimation.done)="resetChosenValue()">
    <div class="side front">
      <div class="dot">{{chosenValue}}</div>
    </div>
    <div class="side top">
      <div class="dot">2</div>
    </div>
    <div class="side right">
      <div class="dot">3</div>
    </div>
    <div class="side left">
      <div class="dot">4</div>
    </div>
    <div class="side bottom">
      <div class="dot">5</div>
    </div>
    <div class="side back">
      <div class="dot">6</div>
    </div>
  </div>
</div>
`,
  styles: [`#wrapper{--text-color:black;--background-color:white;position:relative;width:50px;height:50px;padding:12px;margin:0 auto;transition:all .3s linear}#wrapper.rdDark{--text-color:white;--background-color:#07384c}#dice{position:absolute;width:50px;height:50px;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;transition:all .3s linear}#dice .side{position:absolute;width:50px;height:50px;background:var(--background-color);box-shadow:inset 0 0 5px #000}#dice .side.front{-webkit-transform:translateZ(25px);transform:translateZ(25px)}#dice .side.back{-webkit-transform:rotateX(-180deg) translateZ(25px);transform:rotateX(-180deg) translateZ(25px)}#dice .side.right{-webkit-transform:rotateY(90deg) translateZ(25px);transform:rotateY(90deg) translateZ(25px)}#dice .side.left{-webkit-transform:rotateY(-90deg) translateZ(25px);transform:rotateY(-90deg) translateZ(25px)}#dice .side.top{-webkit-transform:rotateX(90deg) translateZ(25px);transform:rotateX(90deg) translateZ(25px)}#dice .side.bottom{-webkit-transform:rotateX(-90deg) translateZ(25px);transform:rotateX(-90deg) translateZ(25px)}#dice .side .dot{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);font-size:15px;color:var(--text-color);text-shadow:1px 1px 2px rgba(0,0,0,.5)}`],
  animations: [
    trigger('turnAnimation', [
      transition('false => true', animate('2.5s linear', keyframes([
        style({transform: 'translateZ(-100px) rotateX(0deg) rotateY(0deg) rotateZ(0deg)', offset: 0}),
        style({transform: 'translateZ(-100px) rotateX(180deg) rotateY(180deg) rotateZ(0deg) scale(0.8)', offset: 0.16}),
        style({transform: 'translateZ(-100px) rotateX(360deg) rotateY(90deg) rotateZ(180deg) scale(0.8)', offset: 0.33}),
        style({transform: 'translateZ(-100px) rotateX(360deg) rotateY(360deg) rotateZ(360deg) scale(0.8)', offset: 0.5}),
        style({transform: 'translateZ(-100px) rotateX(180deg) rotateY(360deg) rotateZ(270deg) scale(0.8)', offset: 0.66}),
        style({transform: 'translateZ(-100px) rotateX(180deg) rotateY(180deg) rotateZ(180deg) scale(0.8)', offset: 0.83}),
        ])),
      )
    ])
  ]
})
export class RDDiceComponent implements OnInit, OnChanges {

  @Input() diceSize = 6;

  @Output() rollValue: EventEmitter<any> = new EventEmitter();

  public chosenValue = 1;
  public rolling = false;
  public dark = false;

  constructor(private darkService: RDDarkService) {
  }

  ngOnInit() {
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

  ngOnChanges(changes) {
    this.diceSize = Math.max(Math.min(this.diceSize, 100), 6);
  }

  rollDice() {
    this.rolling = true;
  }

  resetChosenValue() {
    if (this.rolling === true) {
      this.chosenValue = Math.floor(Math.random() * 100 % this.diceSize) + 1;
      this.rollValue.emit(this.chosenValue);
      this.rolling = false;
    }
  }

}
